import * as React from "react";
import Image from "next/image";
import styles from "./weddingPartyModal.module.scss";
import { shimmer, toBase64 } from "@src/utils/shimmer";

interface WeddingPartyModalProps {
  name: string;
  nickname?: string;
  role: string;
  story: string;
  imageUrl: string;
}

const WeddingPartyModal: React.FC<WeddingPartyModalProps> = ({
  name,
  nickname,
  role,
  story,
  imageUrl,
}) => {
  return (
    <div className={styles["wedding-party-modal"]}>
      <div className={styles["wedding-party-modal__content"]}>
        <div className={styles["wedding-party-modal__image-container"]}>
          {imageUrl && (
            <Image
              placeholder="blur"
              blurDataURL={`data:image/svg+xml;base64,${toBase64(
                shimmer(400, 500)
              )}`}
              layout="fill"
              objectFit="cover"
              src={imageUrl}
              alt={name}
            />
          )}
        </div>

        <div className={styles["wedding-party-modal__text-content"]}>
          <div className={styles["wedding-party-modal__header"]}>
            <h2
              className={`${styles["wedding-party-modal__name"]} font-oceanTrace`}
            >
              {name}
              {nickname && (
                <span className={styles["wedding-party-modal__nickname"]}>
                  "{nickname}"
                </span>
              )}
            </h2>
            <p className={`${styles["wedding-party-modal__role"]} font-inter`}>
              {role}
            </p>
          </div>

          <div className={styles["wedding-party-modal__story"]}>
            <article>{story}</article>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeddingPartyModal;
